export const locale = {
  lang: "fr",
  data: {
    phone: {
      ext: "Ext.",
    },
    addresses: {
      title: "Gestion des adresses",
      current: "Présent",
      future: "Futur",
      correctAddress: "Corriger l'adresse",
      correctEffectiveDate: "Changer la date de début",
      no: "Non",
      yes: "Oui",
      ok: "Ok",
    },
    memberLocalisation: {
      residencePlace: {
        title: "Résidence",
        current: "Actuelle",
        comingAddressChange: "Changement à venir",
        phones: "Téléphones",
        phone1: "Téléphone",
        phone2: "Téléphone 2",
        address: "Adresse",
        startingOn: "À compter du",
        endingOn: "Termine le",
        changeResidence: "Effectuer un changement de résidence",
        confirmDeleteDomicileProfessional:
          "Supprimer l'assignation comme lieu de pratique principal",
        confirmDeleteDomicileProfessionalMessage:
          "Cette résidence est assignée comme domicile professionel dans le futur. Pour l'anuller, il faut aussi supprimer cette assignation",
        cancelResidenceChange:
          "Voulez-vous vraiment annuler le changement d'adresse",
        menu: {
          changeResidence: "Changer de lieu de résidence",
          correctResidence: "Corriger l'adresse",
          correctChange: "Corriger le changement",
          cancelChange: "Annuler le changement",
        },
        dialog: {
          addResidence: "Ajouter un lieu de résidence",
          correctResidenceChange: "Corriger le changement",
          cancelResidenceChange: "Annuler le changement",
        },
        errors: {
          effectiveDateTaken: "Une autre résidence commence à cette date",
        },
      },
      professionalDomicile: {
        title: "Domicile professionnel",
        current: "Actuel",
        comingAddressChange: "Changement à venir",
        clinic: "Clinique",
        phone: "Téléphone",
        fax: "Télécopieur",
        address: "Adresse",
        wheelchairAccess: "Accès pour un fauteuil roulant",
        typeOfPractice: "Type de pratique à cette adresse",
        isInCompany: "Au sein d'une société, compagnie ou entreprise",
        professionalDomicileSince: "Domicile professionel à compter du",
        practicePlace: "Lieu d'exercice",
        practicePlaceSince: "Pratique à ce lieu depuis le",
        noPracticePlacesInEffect: "Aucun lieu d'exercice effectif à cette date",
        typeOfplace: "Type de lieux",
        changeProfessionalDomicile:
          "Effectuer un changement de domicile professionel",
        cancelChange: "Annuler le changement de domicile professionel",
        menu: {
          correctPracticePlaceInfos: "Corriger l'adresse",
          define: "Changer de lieu d'exercice principal",
          correctInformation: "Corriger l'adresse",
          correctChange: "Corriger le changement de domicile professionnel",
          cancelChange: "Annuler le changement de domicile professionnel",
        },
        dialog: {
          correctInformation: {
            title: "Corriger l'information d'un domicile professionel",
            searchPlaceholder:
              "Rechercher une clinique existante ou entrer son nom",
            clinicName: "Clinique",
            address: "Adresse",
            phone: "Téléphone",
            fax: "Télécopieur",
            practiceSince: "Pratique à ce lieu depuis le",
            practiceUntil: "Ne pratique plus depuis le",
            wheelChairAccess: "Accès fauteuil roulant",
            practiceType: "Type de pratique à cette adresse",
            company: "Dans la société",
            isAssociate: "Est associé",
            isEmployee: "Est employé",
            isSelfEmployed: "Est travailleur autonome",
          },
        },
      },
      secondaryPracticePlace: {
        title: "Lieux de pratique",
        addPracticePlace: "Ajouter un lieu de pratique",
        searchPlaceholder:
          "Rechercher une clinique existante ou entrer son nom",
        clinicName: "Clinique",
        address: "Adresse",
        phone: "Téléphone",
        fax: "Télécopieur",
        practiceSince: "Pratique à ce lieu depuis le",
        practiceUntil: "Ne pratique plus depuis le",
        wheelChairAccess: "Accès fauteuil roulant",
        practiceType: "Type de pratique à cette adresse",
        otherPracticeType: "Autre milieu de pratique",
        otherPracticeTypeAddress: 'Autre type de pratique à cette adresse',
        otherProfessionalContext: 'Autre contexte professionnel',
        professionalEnvironment: 'Milieu de pratique',
        professionalContext: 'Contexte professionnel',
        practiceTypeAddress: 'Type de pratique',
        company: "Dans la société",
        reason: "À titre de",
        principal: "Principal",
        nextPrincipal: "Principal à venir",
        comingPracticePlaces: "Lieux de pratique à venir",
        confirmDeleteDomicileProfessional:
          "Supprimer l'assignation comme lieu de pratique principal",
        confirmDeleteDomicileProfessionalMessage:
          "Ce Lieu de pratique est assigné comme lieu de pratique principal dans le futur. Pour le fermer, il faut aussi supprimer cette assignation",
        removePracticePlaceDate: "Terminer le lieu de d'exercice à cette date:",
        cannotRemoveLastWorkPlaceIfActive:
          "Vous ne pouvez pas terminer votre dernier lieu d'exercice lorsque votre statut est Actif",
        startDateAsPrincipal:
          "Date de début en tant que lieu d'exercice principal",
        addDialog: {
          title: "Ajouter un lieu de pratique",
          isCompanyAddress: "Au sein d'une société, compagnie ou entreprise",
          isAssociate: "Est actionnaire",
          isSelfEmployed: "Est travailleur autonome",
          isEmployee: "Est employé",
          companyName: "Nom de la société",
        },
        correctDialog: {
          title: "Corriger un lieu de pratique",
        },
        addressChangeError:
          "Vous souhaitez apporter des modifications concernant vos lieux d'exercice, voici la marche à suivre :<br/><br/>• Pour <strong>RETIRER</strong> une adresse active : vous NE POUVEZ SUPPRIMER une adresse active au tableau de l'Ordre.<br/>Pour retirer cette adresse, vous DEVEZ indiquer une date de fin d'exercice à cette adresse, ce qui aura pour effet de la rendre inactive au tableau.<br/><br/>• Pour <strong>MODIFIER</strong> une adresse active : vous POUVEZ MODIFIER un renseignement concernant une adresse active au tableau de l'Ordre (ex. numéro de téléphone, adresse, nom de la clinique),<br/>en remplaçant tout simplement le.s renseignement.s à modifier dans la section concernée.<br/><br/>• Pour <strong>AJOUTER</strong> une adresse active : Vous POUVEZ AJOUTER un nouveau lieu d'exercice en saisissant tout simplement les renseignements requis dans chacune des sections.",
        reasonTitles: {
          isAssociate: "Actionaire",
          isEmployee: "Employé",
          isSelfEmployed: "Travailleur autonome",
        },
        menu: {
          correctPracticePlaceInfo: "Corriger l'adresse",
          removePracticePlace: "Terminer ce lieu d'exercice",
          removeMessage: "Voulez-vous terminer ce lieu d'exercice?",
          defineAsMainPracticePlace: "Définir comme lieu d'exercice principal",
          cancelFutureMainPracticePlace:
            "Annuler comme futur lieu d'exercice principal",
          cancelFutureMainPracticePlaceMessage:
            "Voulez-vous annuler ce futur lieu d'exercice principal",
          defineAsMainPracticePlaceMessage:
            "Voulez-vous définir comme lieu d'exercice principal ?",
          correctEndDate: "Corriger la date de fin du lieu d'exercice",
          correctStartDate: "Corriger la date de début du lieu d'exercice",
          cancelChange: "Annuler le retrait de ce lieu d'exercice",
          cancelFutureWorkplace: "Annuler ce lieu d'exercice",
          cancelFutureWorkplaceMessage:
            "Voulez-vous vraiment annuler ce lieu d'exercice ?",
          cancelEndDate: "Annuler la date de fin du lieu d'exercice",
          cancelEndDateMessage:
            "Voulez-vous annuler la date de fin du lieu d'exercice ?",
        },
      },
      correspondencePlace: {
        title: "Adresse postale",
        subTitle:
          "Adresse de correspondance avec l’Ordre des dentistes du Québec.",
        current: "Actuel",
        phone1: "Téléphone",
        phone2: "Téléphone 2",
        phones: "Téléphones",
        fax: "Télécopieur",
        address: "Adresse",
        typeOfPlace: "Type de lieux",
        startingOn: "À compter du",
        endingOn: "Termine le",
        correspondence: "Correspondance",
        residence: "Résidence",
        professionalDomicile: "Domicile professionnel",
        changeCorrespondenceType: "Effectuer un changement de correspondance",
        changeYourCorrespondenceTo:
          "Effectuer un changement de correspondance pour",
        comingChange: "Changement à venir",
        menu: {
          cancelCorrespondencePlaceChange: "Annuler le changement",
        },
        cancelCorrespondencePlaceChange: {
          areYouSure:
            "Voulez-vous vraiment annuler le changement de type de correspondance",
        },
      },
    },
  },
};
